import { paramToStr } from '../index';

// 浏览器端位置处理类
class WapLocation {
    constructor() {}

    getLocation() {
        return new Promise((resolve, reject) => {
            if ('geolocation' in navigator) {
                /* 地理位置服务可用 */
                try {
                    if (location.protocol === 'https:') {
                        navigator.geolocation.getCurrentPosition(
                            function success(res) {
                                resolve({
                                    latitude: res.coords.latitude,
                                    longitude: res.coords.longitude,
                                });
                            },
                            function error() {
                                reject('用户拒绝授权');
                            }
                        );
                    } else {
                        reject('地理位置不可用');
                    }
                } catch (err) {
                    reject('地理位置不可用');
                }
            } else {
                /* 地理位置服务不可用 */
                console.error('地理位置不可用');
                reject('地理位置不可用');
            }
        });
    }

    openLocation(options) {
        console.log('open wap location');
        console.log(options);
        // http://api.map.baidu.com/geocoder?location=39.990912172420714,116.32715863448607
        // &coord_type=gcj02&output=html&src=webapp.baidu.openAPIdemo
        // let query = paramToStr({
        //     location: `${options.latitude},${options.longitude}`,
        //     coord_type: 'wgs84',
        //     output: 'html',
        //     src: 'webapp.zzc.black',
        //     title: options.name,
        //     content: options.address
        // });
        // let link = `http://api.map.baidu.com/marker?${query}`;
        // 高德地图
        this.getLocation().then(res => {
            let query = paramToStr({
                from: `${res.longitude},${res.latitude}`,
                to: `${options.longitude},${options.latitude}`,
                coordinate: 'wgs84',
                callnative: 1,
                src: 'webapp.zzc.black',
            });
            let link = `https://uri.amap.com/navigation?${query}`;
            window.location.href = link;
        });
    }
}

export default WapLocation;
